import { publicApi } from './index';

export const forgotPassword = (data : any) =>
  publicApi.post('/authentication/forgot-password', data);